import React from "react";
import { alpha, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Timer } from "../../types/models/AssetSymbol";
import { AppState, dispatch, useSelector } from "../../store/store";
import { homeActions } from "../../store/slices/homeSlice";
import { theme } from "../../constants";

interface CardProps {
  symbol: string;
  loading: boolean;
}

const TimerCard: React.FC<CardProps> = ({ symbol }) => {
  const { t } = useTranslation();
  const { currentTimer, assetTimers } = useSelector<AppState["home"]>(
    ({ home }) => home
  );
  const onClick = (timer: Timer) => {
    dispatch(homeActions.setCurrentAssetTimer({ timer }));
  };

  return (
    <div className="home__timer-card_container">
      {assetTimers.map((timer: Timer) => {
        const isActive = currentTimer?.id === timer.id;

        return (
          <div
            className={`home__timer-card`}
            style={{
              backgroundColor: isActive
                ? theme.colors.colorCard
                : alpha(theme.colors.colorCard, 0.3),
            }}
            onClick={() => onClick(timer)}
          >
            <Typography variant="body1" color="white">
              {timer.label}
            </Typography>
            <Typography variant="body1" color="success">
              +{timer.expectedReturn}%
            </Typography>
            <Typography variant="body2" color="white">
              {t("minimum")}
            </Typography>
            <Typography variant="body2" color="white">
              {timer.minimum}.00$
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default TimerCard;
